import { render } from "./UserNameWithBadge.vue?vue&type=template&id=70d6c330&scoped=true"
import script from "./UserNameWithBadge.vue?vue&type=script&lang=js"
export * from "./UserNameWithBadge.vue?vue&type=script&lang=js"

import "./UserNameWithBadge.vue?vue&type=style&index=0&id=70d6c330&scoped=true&lang=css"

import exportComponent from "D:\\PROJET WEB\\carpoolear\\carpoolear_frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70d6c330"]])

export default __exports__